import gql from 'graphql-tag';

export const removeLeagueMutation = gql`
	mutation RemoveLeague($id: ID!) {
		removeLeague(id: $id) {
			id
		}
	}
`;
